import { Link } from 'react-router-dom';
import { Button } from '@/components/Button';
import { setConsent, useConsent } from '@/lib/consent';

/**
 * Opt-in banner for analytics cookies, shown to visitors in Europe (see
 * `@/lib/consent`) and to anyone who reopens it from "Cookie settings".
 * Non-modal: it doesn't trap focus or block the page, and Accept and Decline
 * carry equal weight.
 */
export function CookieBanner() {
  const { bannerOpen } = useConsent();
  if (!bannerOpen) return null;

  return (
    <section
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-surface shadow-lg"
    >
      <div className="mx-auto flex max-w-content-wide flex-col gap-4 px-5 py-5 md:flex-row md:items-center md:justify-between md:px-10 lg:px-20">
        <p className="max-w-[640px] text-body-sm text-text-primary">
          We&rsquo;d like to use Google Analytics cookies to understand how people use our public
          pages. They stay off unless you accept. See our{' '}
          <Link to="/privacy" className="underline underline-offset-4 hover:text-accent">
            privacy policy
          </Link>
          .
        </p>
        <div className="flex shrink-0 gap-3">
          <Button size="sm" variant="secondary" onClick={() => setConsent('denied')}>
            Decline
          </Button>
          <Button size="sm" onClick={() => setConsent('granted')}>
            Accept analytics
          </Button>
        </div>
      </div>
    </section>
  );
}
